var map = {
	"./bag1.png": "9a6c",
	"./bag2.png": "7499",
	"./bag3.png": "5ba4",
	"./hat1.png": "586e",
	"./jacket1.png": "7ecb",
	"./jacket2.png": "5a0f",
	"./jeans1.png": "e526",
	"./shoe1.png": "760d",
	"./shoe2.png": "b90d",
	"./shoe3.png": "0c99",
	"./shoe4.png": "573a",
	"./sweater1.png": "45a8",
	"./tshirt1.png": "a2e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4391";